import {FUIIcon} from "../../../icons/icon/icon.model";

export class FUIOptionMetaData {
    public icon: FUIIcon;
    public groupHeading: string;

    constructor(optionMetaData?: any) {
        this.icon = optionMetaData && optionMetaData.icon || null;
        this.groupHeading = optionMetaData && optionMetaData.groupHeading || null;
    }
}
